import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ALERT_NOTIFICATION_GET,
  ALERT_NOTIFICATION_PATCH_READ,
} from '../endpoints/alert-notification.endpoints';
import {
  AlertNotification,
  AlertNotificationDetail,
} from 'src/app/core/models/alert-notification.models';

/**
 * Transport of the `/alert_notification/*` root (WAP-1860): one recipient row
 * of the session user. The list, the count and mark-all-read live under the
 * `/user` root in `UserApiService`.
 */
@Injectable({ providedIn: 'root' })
export class AlertNotificationApiService {
  private readonly http = inject(HttpClient);

  /** The detail of one of the user's rows: trigger snapshot, posts, deliveries. */
  getAlertNotification(eventId: number): Observable<AlertNotificationDetail> {
    return this.http.get<AlertNotificationDetail>(
      ALERT_NOTIFICATION_GET(eventId),
    );
  }

  /** Sets `time_read` when it is null; answers the row either way. */
  markAlertNotificationRead(eventId: number): Observable<AlertNotification> {
    return this.http.patch<AlertNotification>(
      ALERT_NOTIFICATION_PATCH_READ(eventId),
      {},
    );
  }
}
